<template>
  <v-row>
    <v-col class="py-0 max-w-50px">
      <v-checkbox
        :class="{ 'mt-9': !noMargin }"
        class="mr-5"
        v-model="checkbox"
        :disabled="disabled"
        @change="onCheckboxClicked($event)"
      ></v-checkbox>
    </v-col>
    <v-col class="py-0">
      <paragraph class="mb-1"><slot></slot></paragraph>
      <v-text-field
        v-model="localVal"
        @keyup="$emit('update:value', localVal)"
        color="primary"
        :label="label"
        :type="type"
        :disabled="!checkbox"
        :rules="rules"
      ></v-text-field>
      <slot name="bottom"></slot>
    </v-col>
  </v-row>
</template>

<script>
import Paragraph from "@/components/ui/Paragraph.vue";

export default {
  name: "InputWithCheckbox",
  components: {
    Paragraph
  },
  props: {
    checked: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "text"
    },
    label: {
      type: String,
      default: ""
    },
    noMargin: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      checkbox: false,
      localVal: ""
    };
  },
  watch: {
    value(newVal) {
      this.localVal = newVal;
    },
    checked(newVal) {
      this.checkbox = newVal;
    }
  },
  methods: {
    onCheckboxClicked(val) {
      this.$emit("update:checked", val);
      if (!val) {
        this.$emit("update:value", "");
      }
    }
  }
};
</script>
